export default __webpack_public_path__ + "static/media/Khosla Profil Private Limited.b283575c.jpg";